import { schemaItems } from './schemaItems';

export const workflowSteps = $axios => ({
  // nested resources
  schemaItems: schemaItems($axios),
});
